function splideSliderInit() {
	const splideSlider = ".splide";
	let splideSliderBlock = document.querySelectorAll(splideSlider);

	const updateHeroFirstVideoSlide = () => {
		const splideSlider = !document.querySelectorAll(".voyager-hero .splide")
			.length
			? document.querySelectorAll(".voyager-hero-mobile .splide")
			: document.querySelectorAll(".voyager-hero .splide");

		splideSlider.forEach((slider) => {
			const isInitialized = slider.classList.contains("is-initialized");
			if (isInitialized) return false;

			// Reset first slide class
			const firstSlide = slider.querySelector(".splide__slide");
			const heroFirstSlideVideo = firstSlide?.querySelector("video");

			if (heroFirstSlideVideo) {
				heroFirstSlideVideo.classList.remove("js-voyager-video");
				heroFirstSlideVideo.classList.add("js-voyager-video-first-slide");
			}
		});
	};

    const alignCarouselArrows = (splideElement, variations) => {
        if (!splideElement || !variations.length) return false;

        const hasClassFromArray = (element, classArray) => {
            if (!element) return false;
            return classArray.some((className) =>
                element.classList.contains(className)
            );
        };

        const closestSection = splideElement.closest("section");
        if (!closestSection || !hasClassFromArray(closestSection, variations)) {
            return false;
        }

        // Find the splide__track element inside the carousel
        const track = splideElement.querySelector(".splide__track");

        if (!track) return false;

        // Get the computed style of the splide__track to determine padding
        const style = getComputedStyle(track);
        const paddingLeft = parseFloat(style.paddingLeft) || 0;
        const paddingRight = parseFloat(style.paddingRight) || 0;

        // Calculate the width of the splide__track excluding padding
        const trackWidth = track.offsetWidth - paddingLeft - paddingRight;

        // Find the left and right arrow elements
        const prevArrow = splideElement.querySelector(".splide__arrow--prev");
        const nextArrow = splideElement.querySelector(".splide__arrow--next");

        if (prevArrow && nextArrow) {
            // Set the left and right CSS properties to align with the splide__track
            prevArrow.style.left = `${track.offsetLeft + paddingLeft}px`;
            nextArrow.style.right = `${track.offsetLeft + paddingRight}px`;
        }
    };

	if (typeof splideSliderBlock != "undefined" && splideSliderBlock != null) {
		// Update the Hero Slider First slide Video Class to initialize video with the Splide slider
		updateHeroFirstVideoSlide();

		for (var i = 0; i < splideSliderBlock.length; i++) {
			const splideElement = splideSliderBlock[i];
			const firstSlide = splideElement.querySelector(".splide__slide");

			const heroFirstSlideVideo = firstSlide?.querySelector("video");

			// State
			let hasAutoplay = false;
			let splide = {};
			let autoplay = {};
			let isAutoplayResumed = false;

			function initSlider(hasFirstVideoSlide) {
				// SET DEFAULT OPTIONS
				var splideDefaultOptions = {
					type: "slide",
					autoplay: true,
					interval: 6000,
					lazyLoad: "nearby",
					pauseOnHover: false,
					resetProgress: false,
					arrows: false,
					pagination: false,
					gap: 0,
					grid: false,
				};
				splide = new Splide(splideElement, splideDefaultOptions);

				// Set a flag if first slide contains a video
				hasFirstVideoSlide && (splide.root.hasFirstSlideVideo = true);

				splide.on("autoplay:play", function () {
					hasAutoplay = true;
				});

				let bar = splide.root.querySelector(".splide__progress-bar");
				// Update the bar width:
				if (bar) {
					splide.on("ready move", () => {
						var end = splide.Components.Controller.getEnd() + 1;
						var rate = Math.min((splide.index + 1) / end, 1);
						bar.style.width = String(100 * rate) + "%";
					});
				}

				// Remove all of the clones when we update the blocks using Gutenberg, prevents issues in the admin!
				if (
					splideElement.classList.contains("is-initialized") &&
					document.body.classList.contains("wp-admin")
				) {
					// Destroy the slider on switching variations
					splideElement.querySelector(".splide__destroy-button")?.click();
				}

				splide.on("mounted", function () {
					// Define slider Autoplay controls to sync slider autoplay with video
					const sliderAutoplay = splide.Components.Autoplay;
					sliderAutoplay &&
						Object.defineProperties(splide.root, {
							sliderAutoplay: { value: sliderAutoplay, writable: true },
						});

					autoplay = splide.Components.Autoplay;

					// Pause the autoplay if the first slide has video
					if (hasFirstVideoSlide && hasAutoplay) {
						autoplay.pause();
						isAutoplayResumed = false;
						/* console.log(
						  "%cAutoplay Paused",
						  "color: red; background: yellow; font-size: 30px"
						); */
					}

					// Align carousel arrows with the splide track width for the selected splide variations
					alignCarouselArrows(splideElement, ["voyager-gallery--variation-group"]);

					if (!splideElement.querySelector(".splide__destroy-button")) {
						addDestroyButton(splide);
					} else {
						splideElement.querySelector(".splide__destroy-button").remove();
						addDestroyButton(splide);
					}
				});

				splide.on("moved", function (newIndex, prevIndex, destIndex) {
					// Set the previous slide video from the beginning, and pause on slide change
					const prevSlide = splide.Components.Slides.getAt(prevIndex).slide;
					const prevSlideVideo = prevSlide.querySelector(".video-js");
					prevSlideVideo &&
						(prevSlideVideo.player.currentTime(0),
							prevSlideVideo.player.pause());

					// Play the current slide video if it has autoplay enabled
					const newSlide = splide.Components.Slides.getAt(newIndex).slide;
					const newSlideVideo = newSlide.querySelector(".video-js");
					newSlideVideo &&
						newSlideVideo.player.autoplay() &&
						newSlideVideo.player.play();

					// set the first slide video ended flag to true
					splide.root.hasFirstSlideVideo &&
						(splide.root.isFirstSlideVideoEnded = true);

					// Resume slider autoplay on slide change
					if (hasAutoplay && autoplay.isPaused()) {
						autoplay.play();
						isAutoplayResumed = true;
					}
				});

				// Start the carousels
				splide.mount(window.splide.Extensions);

				// Check if carousel has filters, then handle the filtering if exists
				if (splideSliderBlock[i].parentNode.classList.contains('voyager-carousel__splide-filter-popup') || splideSliderBlock[i].parentNode.classList.contains('voyager-carousel__splide-filter')) {
					let splideNode = splideSliderBlock[i].parentNode.parentNode.parentNode;
					const carouselSlider = new CarouselSlider(splideNode);
					carouselSlider.filterInit(splide)
				}

				// Check if carousel requires the navigation titles
				if (splideSliderBlock[i].parentNode.classList.contains('js-slider-navigation-titles')) {
					const fiftyFiftySlider = new Fifty_Fifty_Slider(splide);
				}

				function addDestroyButton(splide) {
					const destroyButton = document.createElement("button");
					destroyButton.classList.add("splide__destroy-button");
					destroyButton.textContent = "Destroy";
					destroyButton.style.position = "absolute";
					destroyButton.style.visibility = "hidden";
					destroyButton.addEventListener("click", () => {
						splide.destroy();
					});
					splideElement.appendChild(destroyButton);
				}

				return autoplay;
			}

			if (heroFirstSlideVideo) {
				// Initialize the slider
				initSlider(true);

				// Initialize the video JS
				const videoJs = new VideoJs({
					selector: ".js-voyager-video-first-slide",
				});
				// Start the slider autoplay on video load
				videoJs.init([
					{
						eventType: "onended",
						cb() {
							if (hasAutoplay && !isAutoplayResumed) {
								splide.go("+1");
								autoplay.play();
								isAutoplayResumed = true;

								// Set a flag if the first slide ENDS the video
								splide.root.isFirstSlideVideoEnded = true;

								/* console.log(
								  "%c Autoplay RESUMED",
								  "color: green; background: yellow; font-size: 30px"
								); */
							}
						},
					},
				]);
			} else {
				initSlider();
			}
		}
	}
} // is-initialized

/**
 * Initialize the script when the block is previewed within the editor
 * https://www.advancedcustomfields.com/resources/javascript-api/
 */
if (window.acf) {
	window.acf.addAction(
		"render_block_preview/type=voyager-carousel",
		splideSliderInit
	);
	window.acf.addAction(
		"render_block_preview/type=voyager-logos",
		splideSliderInit
	);
	window.acf.addAction(
		"render_block_preview/type=voyager-testimonials",
		splideSliderInit
	);
	window.acf.addAction(
		"render_block_preview/type=voyager-features",
		splideSliderInit
	);
	window.acf.addAction(
		"render_block_preview/type=voyager-hero",
		splideSliderInit
	);
	window.acf.addAction(
		"render_block_preview/type=voyager-hero-with-introduction",
		splideSliderInit
	);
	window.acf.addAction(
		"render_block_preview/type=voyager-instagram-feed",
		splideSliderInit
	);
	window.acf.addAction(
		"render_block_preview/type=voyager-booking-hub",
		splideSliderInit
	);
	window.acf.addAction(
		"render_block_preview/type=voyager-gallery",
		splideSliderInit
	);
	window.acf.addAction(
		"render_block_preview/type=voyager-fifty-fifty-slider",
		splideSliderInit
	);
} else {
	document.addEventListener("DOMContentLoaded", splideSliderInit);
}
